module.exports = __webpack_public_path__ + "img/mockup_ignoto_mac.02fb8aa7.jpg";